import { render, staticRenderFns } from "./exPqcCheckComIndex.vue?vue&type=template&id=5a98a143"
import script from "./exPqcCheckComIndex.vue?vue&type=script&lang=js"
export * from "./exPqcCheckComIndex.vue?vue&type=script&lang=js"
import style0 from "./exPqcCheckComIndex.vue?vue&type=style&index=0&id=5a98a143&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports